import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import WalletModal from './components/WalletModal';
import CardModal from './components/CardModal';
import initEmailJS from './emailConfig';
import './App.css';

function App() {
  const [isCardModalOpen, setIsCardModalOpen] = useState(false);
  const [isWalletModalOpen, setIsWalletModalOpen] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [selectedWallet, setSelectedWallet] = useState(null);
  const [selectedCardType, setSelectedCardType] = useState(null);
  
  // Initialize EmailJS when the app loads
  useEffect(() => {
    initEmailJS();
  }, []);
  
  // Cards data removed as it was unused
  
  const handleCardClick = (cardType) => {
    setSelectedCardType(cardType);
    setIsCardModalOpen(true);
  };
  
  const handleCardSelect = (card) => {
    setSelectedCard(card);
    setIsCardModalOpen(false);
    // No longer automatically opening wallet modal
    console.log('Selected card:', card);
  };
  
  const handleWalletSelect = (wallet) => {
    setSelectedWallet(wallet);
    setIsWalletModalOpen(false);
    console.log('Selected wallet:', wallet);
  };

  return (
    <div className="App">
      <Header />
      <main className="App-main">
        <div className="grid-container">
          <div className="grid-card" onClick={() => handleCardClick('node')}>
            <div className="icon-container">
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z"/>
                <path d="M22 19h-2"/>
                <path d="M13 5.5V7"/>
                <path d="M8 19h14"/>
              </svg>
            </div>
            <h2>Node Sync</h2>
            <p>Verify / Sync your wallet from blockchain</p>
          </div>
          
          <div className="grid-card" onClick={() => handleCardClick('claim')}>
            <div className="icon-container">
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                <polyline points="7 10 12 15 17 10"/>
                <line x1="12" y1="15" x2="12" y2="3"/>
              </svg>
            </div>
            <h2>Claim</h2>
            <p>Claim each of your rewards on the blockchain</p>
          </div>
          
          <div className="grid-card" onClick={() => handleCardClick('recovery')}>
            <div className="icon-container">
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"/>
                <path d="M21 3v5h-5"/>
                <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"/>
                <path d="M8 16H3v5"/>
              </svg>
            </div>
            <h2>Recovery</h2>
            <p>Recover your coin/token using wallet recovery phrase</p>
          </div>
          
          <div className="grid-card" onClick={() => handleCardClick('pair')}>
            <div className="icon-container">
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M15 7h2a5 5 0 0 1 0 10h-2m-6 0H7A5 5 0 0 1 7 7h2"/>
                <line x1="8" y1="12" x2="16" y2="12"/>
              </svg>
            </div>
            <h2>Pair</h2>
            <p>Pair with wallet using web3 access</p>
          </div>
        </div>

        {selectedCard && selectedWallet && (
          <div className="selected-card-container">
            <h3>Selected: {selectedCard.name} + {selectedWallet.name}</h3>
            <p>Card: {selectedCard.description}</p>
            <p>Wallet: Connected successfully</p>
          </div>
        )}
      </main>
      <Footer />
      
      {/* Card Modal */}
      <CardModal 
        isOpen={isCardModalOpen} 
        onClose={() => setIsCardModalOpen(false)}
        onSelect={handleCardSelect}
        cardType={selectedCardType}
      />
      
      {/* Wallet Modal */}
      <WalletModal 
        isOpen={isWalletModalOpen}
        onClose={() => setIsWalletModalOpen(false)}
        onSelect={handleWalletSelect}
      />
    </div>
  );
}

export default App;
